import React from 'react';
import { makeStyles, createStyles, Grid } from '@material-ui/core';

import { PageLocation } from '../../../shared/enum/PageLocation';
import { HomeContext } from '../../Home/HomeContext';
import { JournalistModel, journalistModelInitial } from '../../../Models/JournalistModel';
import { JournalistContext } from '../JournalistContext';
import { JournalistInput } from './JournalistInput';
import { JournalistSearch } from './JournalistSearch';

const useStyles = makeStyles(() => createStyles({
    gridContainer: {
        maxWidth: '1152px',
        margin: 0
    },
}));
 
export function Journalist() {
    const classes = useStyles();    

    const homeContext = React.useContext(HomeContext);

    const [journalist, setJournalist] = React.useState<JournalistModel>(journalistModelInitial);
    const [journalistList, setJournalistList] = React.useState<JournalistModel[]>([]); 
    
    return (
        <JournalistContext.Provider value={{
            journalist, setJournalist,
            journalistList, setJournalistList
        }}>
            <Grid container justify="center" alignItems="center">
                <Grid container justify="center" className={classes.gridContainer} spacing={2}>   
                    {homeContext.pageLocation === PageLocation.JOURNALIST_INPUT && <JournalistInput /> }
                    {homeContext.pageLocation === PageLocation.JOURNALIST_SEARCH && <JournalistSearch /> }
                </Grid>
            </Grid>
        </JournalistContext.Provider>
    );
}